module.exports = __webpack_public_path__ + "img/home-brands-wasa.jpg?f2badf39633e027a36b3d07aad588bc2";